import { render } from "./ConfirmationComponent.vue?vue&type=template&id=33abefd7"
import script from "./ConfirmationComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmationComponent.vue?vue&type=script&lang=js"

import "./ConfirmationComponent.vue?vue&type=style&index=0&id=33abefd7&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__